import React from "react";
import PropTypes from "prop-types";

export const CompaniesListIcon = (props) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_1194_1920)">
          <path
            d="M3 5.00024H3.01M3 12.0002H3.01M3 19.0002H3.01M8 5.00024H21M8 12.0002H21M8 19.0002H21"
            stroke={props.selectedIcon ? "#448BCA" : "#6B778C"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1194_1920">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

CompaniesListIcon.propTypes = {
  selectedIcon: PropTypes.bool,
};
